import { NavLink, useNavigate } from 'react-router-dom';
import { useLogout } from '../../hooks/useAuth';
import { cn } from '../../lib/utils';

const ADMIN_NAV = [
  { to: '/admin/dashboard', label: 'ОГЛЯД' },
  { to: '/admin/orders', label: 'ЗАМОВЛЕННЯ' },
  { to: '/admin/users', label: 'КОРИСТУВАЧІ' },
  { to: '/admin/products', label: 'ТОВАРИ' },
];

// Admin accounts get this instead of the customer Header — no catalog, cart, or
// favorites, since an admin session is a separate internal tool, not a shopping
// session (per the user's explicit request: "тількі админка все инше мени не треба").
export function AdminHeader() {
  const navigate = useNavigate();
  const logout = useLogout();

  return (
    <header className="sticky top-0 z-20 flex flex-wrap items-center gap-4 border-b border-line bg-bg/[0.92] px-6 py-[14px] backdrop-blur-[8px]">
      <button
        type="button"
        onClick={() => navigate('/admin/dashboard')}
        className="flex items-center gap-2 border-none bg-transparent cursor-pointer p-0"
      >
        <span className="flex h-10 w-[52px] items-center justify-center bg-accent text-[20px] font-bold tracking-[-0.02em] text-bg">
          214°
        </span>
        <span className="mono-label text-[12px]">Адмінка</span>
      </button>

      <nav className="flex flex-1 flex-wrap justify-center gap-1 sm:gap-2">
        {ADMIN_NAV.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              cn(
                'px-2 sm:px-3 py-2 text-[13px] font-semibold',
                isActive ? 'text-ink' : 'text-muted-2',
              )
            }
          >
            {item.label}
          </NavLink>
        ))}
      </nav>

      <button
        type="button"
        onClick={() => logout.mutate()}
        className="border border-stroke bg-transparent px-[14px] py-[9px] font-mono text-[12px] font-bold text-muted cursor-pointer"
      >
        ВИЙТИ
      </button>
    </header>
  );
}
